import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';

const TEXT_LINE_HEIGHT = 22;
const TEXT_LINE_WITH_MEDIA_MOBILE = 4;
const TEXT_LINE_NO_MEDIA_MOBILE = 14;

const TEXT_LINE_WITH_MEDIA_PC = 2;
const TEXT_LINE_NO_MEDIA_PC = 7;

export class PostTitleAndTextFeedView extends Component {

  constructor() {
    super();

    this.goToPostView = this.goToPostView.bind(this);
    this.getContainerSize = this.getContainerSize.bind(this);

    this.state = {
      titleContainerWidth: 0,
      textContainerWidth: 520,
      textContainerHeight: 0
    };
  }

  componentDidMount() {
    this.getContainerSize();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.getContainerSize);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.getContainerSize);
    }
  }

  goToPostView() {
    const { postPath } = this.props;
    window.location.href = postPath;
  };

  getContainerSize() {
    const titleContainer = findDOMNode(this.refs.titleContainer);
    const titleContainerWidth = titleContainer.getBoundingClientRect().width;

    const textContainer = findDOMNode(this.refs.textContainer);
    const textContainerWidth = textContainer.getBoundingClientRect().width;
    const textContainerHeight = textContainer.getBoundingClientRect().height;

    this.setState({
      titleContainerWidth: titleContainerWidth,
      textContainerWidth: textContainerWidth,
      textContainerHeight: textContainerHeight
    });
  }

  render() {
    const { post, postPath, post: { title, text }, device } = this.props;
    const { titleContainerWidth, textContainerWidth, textContainerHeight } = this.state;

    const deviceOsName = device.getIn(['os', 'name']);
    const isPC = deviceOsName !== 'Android' && deviceOsName !== 'iOS';

    const nonMedia = !post.media || post.media.isEmpty();
    const nonText = !text || post.getDescription().trim() === '';

    const textLineNumber = textContainerHeight / TEXT_LINE_HEIGHT;
    const textLineNoTitle = isPC ? TEXT_LINE_NO_MEDIA_PC : TEXT_LINE_NO_MEDIA_MOBILE;
    const textLineWithTitle = isPC ? TEXT_LINE_WITH_MEDIA_PC : TEXT_LINE_WITH_MEDIA_MOBILE;

    const isTitleOver = textContainerWidth < titleContainerWidth;
    const isTextOver = nonMedia ? textLineNumber > textLineNoTitle : textLineNumber > textLineWithTitle;
    const isMoreView = nonText ? isTitleOver : isTextOver;

    const maxHeight = nonMedia ? TEXT_LINE_HEIGHT * textLineNoTitle : TEXT_LINE_HEIGHT * textLineWithTitle;
    const textHeight = nonText ? 0 : Math.min(maxHeight, textContainerHeight);

    const textStyle = {
      height: textHeight,
      display: textContainerHeight > maxHeight ? 'inline-block' : null,
      overflow: textContainerHeight > maxHeight ? 'hidden' : null
    };

    return (
      <div className="post_txt" onClick={this.goToPostView}>
        <strong className="tit_post"><span ref="titleContainer">
            {
                post.isBlind() ? "" : title
            }
        </span></strong>
        <p className="desc_post" ref="textContainer"
          style={{ maxHeight: maxHeight + (2 * TEXT_LINE_HEIGHT), overflow: 'hidden' }}
        >
          <span style={textStyle}>
            {
              text
            }
          </span>
          { isMoreView &&
            // 아래 style 은 '...더보기'를 한 줄 밑으로 내리기로 하면서 추가로 들어감. 본문 옆으로 붙이려면 style 제거.
            <a href={postPath} target="_self" className="link_more"
              style={{ display: 'block', paddingTop: 0 }}>
              …더보기
            </a>
          }
        </p>
      </div>
    );
  }
}

export default PostTitleAndTextFeedView;


// WEBPACK FOOTER //
// ./src/components/PostBox/FeedView/PostTitleAndTextFeedView.js